import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class ExportStockService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Accept': 'application/json' });

  constructor(
    private http: HttpClient, 
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Export all stock to Excel
   * @returns array
   */
  exportAllStock(location:string|null,branch: string|null):Observable<any>{

    const formData = {
      location: location,
      branch:branch
    };

    let apiURL:string=`${this.baseURL}/v1/export/all-stock`;

    return this.http.post(apiURL, formData, { 
      headers: this.headers,
      responseType: 'blob' as 'json' // Expect binary file, not JSON
     }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Export all available stock to Excel
   * @returns array
   */
  exportAvailableStock(location:string|null,branch: string|null):Observable<any>{

    const formData = {
      location: location,
      branch:branch
    };

    let apiURL:string=`${this.baseURL}/v1/export/all-available-stock`;

    return this.http.post(apiURL, formData, { 
      headers: this.headers,
      responseType: 'blob' as 'json' // Expect binary file, not JSON
     }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Export stock en route to Excel
   * @returns array
   */
  exportStockEnroute():Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/export/stock-enroute`;

    return this.http.post(apiURL, {}, { 
      headers: this.headers,
      responseType: 'blob' as 'json' // Expect binary file, not JSON
     }).pipe(catchError(this.errorHandler.handleError));
  }

   /**
   * Export stock on port/CFS to Excel
   * @returns array
   */
   exportStockAtCFS():Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/export/stock-at-cfs`;

    return this.http.post(apiURL, {}, { 
      headers: this.headers,
      responseType: 'blob' as 'json' // Expect binary file, not JSON
     }).pipe(catchError(this.errorHandler.handleError));
  }
}
